import { sellerConstants } from '../../_constants/seller.constants';
import { sellerImageService } from '../../_services/';

export const sellerImageAction = {
    setSellerImage
};

function setSellerImage(data, id) {

    return dispatch => {
        dispatch(request());
        sellerImageService.setSellerImage(data, id)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_ADD_SELLER_IMAGE } }
    function success(data) { return { type: sellerConstants.ADD_SELLER_IMAGE_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.ADD_SELLER_IMAGE_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerImage.actions.js